import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n/i18n";
import "./assets/style/common.scss";
import animate from "animate.css";
import "./assets/font_bottom_logo/iconfont.css"; //引入样式

Vue.config.productionTip = false;
// 跳转后返回顶部
router.afterEach(() => {
  window.scrollTo(0, 0);
});
//使用插件
// 全局获取缓存数据
(Vue.prototype.resetSetItem = function(key, newVal) {
  if (key === "selectNav") {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        localStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          "setItem",
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );

        // 派发对象
        window.dispatchEvent(newStorageEvent);
      },
    };
    return storage.setItem(key, newVal);
  }
}),
  new Vue({
    router,
    store,
    i18n,
    animate,
    render: (h) => h(App),
  }).$mount("#app");
